module.exports = __webpack_public_path__ + "static/flashcard_2-b475ab1acfed70ab22b2a1453cfcfb08.jpg";